
import Vue from 'vue';
import BillingService from '~/services/BillingService';

export default Vue.extend({
    name: 'CancelButton',
    props: {
        subscriptionId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showDialog: false,
            loading: false,
            error: false,
        };
    },
    methods: {
        async renewSubscription() {
            this.loading = true;
            try {
                const res = await BillingService.restartSubscription(this.subscriptionId);

                if (res) this.$router.go(0);
                else this.error = true;
            } catch {
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
    },
});
